import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Input, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { DataStreamService } from '@portal-core/data-stream/services/data-stream.service';
import { NotificationPage } from '@portal-core/notifications/models/notification-page.model';
import { Notification } from '@portal-core/notifications/models/notification.model';
import { NotificationsService } from '@portal-core/notifications/services/notifications.service';
import { NotificationList } from '@portal-core/notifications/util/notification-list';
import { filter } from 'lodash';
import { Observable } from 'rxjs';

@Component({
  selector: 'mc-translation-package-language-branch-notification-list',
  templateUrl: './translation-package-language-branch-notification-list.component.html',
  styleUrls: ['./translation-package-language-branch-notification-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TranslationPackageLanguageBranchNotificationListComponent extends NotificationList implements OnChanges {
  @HostBinding('class.mc-notification-list') notificationListClass = true;
  @Input() translationPackageLanguageBranchId: number;

  constructor(protected notificationsService: NotificationsService, protected dataStreamService: DataStreamService, cdr: ChangeDetectorRef) {
    super(notificationsService, dataStreamService, cdr);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.translationPackageLanguageBranchId) {
      this.onConfigurationChanged();
    }
  }

  protected isConfigured(): boolean {
    return typeof this.translationPackageLanguageBranchId === 'number';
  }

  protected fetchNotifications$(pageSize: number, pageIndex: number): Observable<NotificationPage> {
    return this.notificationsService.getNotificationsByTranslationPackageLanguageId$(this.translationPackageLanguageBranchId, pageSize, pageIndex);
  }

  protected filterNotifications(notifications: { [id: string]: Notification }): Notification[] {
    return filter(notifications, notification => notification.TranslationPackageLanguageBranchId === this.translationPackageLanguageBranchId);
  }
}
